module.exports = __webpack_public_path__ + "assets/img/online_wechat.7a2e2a70.svg";